export class BaseData {
  public action_method: string;
  public param: string;

  constructor(action_method: string, param: any) {
    this.action_method = action_method;
    this.param = param;
  }
}
